import { render, staticRenderFns } from "./AccordionSettings.vue?vue&type=template&id=9241d68e&scoped=true&"
import script from "./AccordionSettings.vue?vue&type=script&lang=ts&"
export * from "./AccordionSettings.vue?vue&type=script&lang=ts&"
import style0 from "./AccordionSettings.vue?vue&type=style&index=0&id=9241d68e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9241d68e",
  null
  
)

export default component.exports